// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__QFdLo","space":"header_space__THz7f","flex":"header_flex__0dioU","btn":"header_btn__ozO0z","logo":"header_logo__bSBFe"};